import React from "react";
import SC from "./style"; // Ensure styles are correctly imported

const AccessDeniedMessage = () => {
  return (
    <SC.AccessDeniedWrapper>
      <div style={{ textAlign: "center" }}>
        <div>
          <p style={{ fontWeight: "bold" }}>No Access</p>
          <p
            style={{
              fontSize: "15px",
              color: "#333",
              maxWidth: "400px",
              margin: "0 auto",
            }}
          >
            It seems that you have no access. Please contact the administrator
            to get access.
          </p>
        </div>
      </div>
    </SC.AccessDeniedWrapper>
  );
};

export default AccessDeniedMessage;
